export interface Entry {
  el: HTMLElement
  value: TrackValue
}

// 埋点数据的结构
export interface TrackValue {
  action?: string // 事件动作/事件行为
  name?: string // 事件名称
  value?: number // 事件数值
}

export interface TrackEvent extends TrackValue {
  category: TrackEventCategory // 事件类别
}

// 事件类别
export enum TrackEventCategory {
  Click = 'click', // 点击事件
  Exposure = 'exposure', // 曝光事件
  Custom = 'custom', // 自定义
}
